interface Props {
  color?: string;
  width?: number;
  height?: number;
}

const Facebook = ({ color = "#1877F2", width = 16, height = 16 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.675 0.5H1.325C1.1062 0.5 0.896354 0.586919 0.741637 0.741637C0.586919 0.896354 0.5 1.1062 0.5 1.325V14.675C0.5 14.8938 0.586919 15.1036 0.741637 15.2584C0.896354 15.4131 1.1062 15.5 1.325 15.5H8.51V9.6875H6.56V7.4375H8.51V5.75C8.46961 5.35382 8.51638 4.9536 8.64704 4.5774C8.77769 4.20121 8.98907 3.85816 9.26635 3.57231C9.54362 3.28646 9.88008 3.06473 10.2521 2.92268C10.6242 2.78063 11.0228 2.72169 11.42 2.75C12.0038 2.74597 12.5872 2.77602 13.1675 2.84V4.865H11.975C11.03 4.865 10.85 5.315 10.85 5.9675V7.415H13.1L12.8075 9.665H10.85V15.5H14.675C14.7833 15.5 14.8906 15.4787 14.9907 15.4372C15.0908 15.3957 15.1818 15.335 15.2584 15.2584C15.335 15.1818 15.3957 15.0908 15.4372 14.9907C15.4787 14.8906 15.5 14.7833 15.5 14.675V1.325C15.5 1.21666 15.4787 1.10938 15.4372 1.00929C15.3957 0.909193 15.335 0.818245 15.2584 0.741637C15.1818 0.665029 15.0908 0.60426 14.9907 0.562799C14.8906 0.521339 14.7833 0.5 14.675 0.5Z"
        fill={color}
      />
    </svg>
  );
};

export default Facebook;
